<template lang="html">
  <section class="templates-page">
    <div class="templates">
      <template-card
        v-for="t in templates"
        :key="t.uuid"
        :app="t"
        :linked-items="getLinkedItems(t.uuid)"
      />
    </div>
  </section>
</template>

<script lang="js">
  import TemplateCard from "@/components/TemplateCard";
  import { mapState } from "vuex";

  export default  {
    name: 'templates-list',
    components: {
      TemplateCard
    },
    props: {},
    computed: {
      ...mapState({
        apps: "apps"
      }),
      templates() {
        return this.apps.filter(a => a.isTemplate);
      }
    },
    methods: {
      getLinkedItems(uuid) {
        return this.apps.filter(a => { return a.sourceTemplateUuid === uuid });
      }
    }
  }
</script>

<style scoped lang="scss">
  .templates-page {
    padding: 1rem;
    .templates {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }
  }
</style>
